import icAiPowered from "@/assets/icons/ic-ai-powered.svg";
import icIntegration from "@/assets/icons/ic-integration.svg";
import icSecurity from "@/assets/icons/ic-security.svg";
import icScalable from "@/assets/icons/ic-scalable.svg";

const features = [
  {
    icon: icAiPowered,
    title: "AI 기반 에이전트",
    description:
      "고객 서비스부터 데이터 분석까지, 귀사의 비즈니스 니즈에 특화된 최첨단 AI 에이전트를 만나보세요.",
  },
  {
    icon: icIntegration,
    title: "즉시 연동",
    description:
      "사용하기 쉬운 플랫폼과 API를 통해 AI 에이전트를 기존 업무 프로세스에 손쉽게 연동해보세요.",
  },
  {
    icon: icSecurity,
    title: "엔터프라이즈 보안",
    description:
      "민감한 데이터를 안전하게 보호하기 위해 국제 표준을 준수하는 은행 수준의 보안 환경을 제공합니다.",
  },
  {
    icon: icScalable,
    title: "확장 가능한 솔루션",
    description:
      "스타트업부터 엔터프라이즈 수준까지, 비즈니스 성장에 맞춰 AI 역량을 유연하게 확장해보세요.",
  },
];

export const WhyChooseSection = () => {
  return (
    <section className="px-5 py-10 lg:px-[100px] lg:py-[100px]">
      <div className="max-w-[1240px] mx-auto flex flex-col items-center gap-8 lg:gap-12">
        {/* Section heading */}
        <div className="flex flex-col items-center gap-2 lg:gap-3">
          <h2 className="text-[36px] leading-[44px] tracking-[-2px] lg:tracking-[-0.0278em] lg:text-display text-black text-center">
            왜 AI Agent Connector를 선택해야 할까요?
          </h2>
          <p className="text-body text-black text-center lg:text-center">
            비즈니스에 AI를 효과적으로 활용하기 위해 필요한 모든 것을 하나의 강력한 플랫폼에서
            제공합니다.
          </p>
        </div>

        {/* Feature cards — horizontal scroll on mobile, grid on desktop */}
        <div className="flex gap-4 lg:gap-6 w-full overflow-x-auto snap-x snap-mandatory lg:overflow-visible -mx-5 lg:mx-0 lg:px-0 scrollbar-hide">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="snap-center shrink-0 w-[292px] lg:flex-1 lg:w-auto flex flex-col pt-8 bg-[#EE834A] rounded shadow-bottom-100"
            >
              {/* White inner card */}
              <div className="bg-white rounded p-8 flex flex-col gap-8 flex-1">
                <img
                  src={feature.icon}
                  alt=""
                  width={48}
                  height={48}
                  className="w-12 h-12 shrink-0"
                />
                <div className="flex flex-col gap-3">
                  <h3 className="text-h2 font-semibold text-black leading-[28px] lg:leading-8">
                    {feature.title}
                  </h3>
                  <p className="text-body text-black">{feature.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
